import { mainApi } from "services/main";
import { CreateTaskFormResponse } from "./definitions";
import { CreateTaskInput } from "components/create-taskgroup-form";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    createTask: builder.mutation<CreateTaskFormResponse, CreateTaskInput>({
      query: (request?: CreateTaskInput) => ({
        url: "tasks",
        body: request,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useCreateTaskMutation } = extendedApi;
